import { useFetchData, useParseRouteActions } from "../../../helpers/GlobalHelper";
import { GlobalConstants } from "../../constants/GlobalConstants";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import LmsTable from "../ui/LmsTable";

const MainTable = () => {
  const actionsButtons = ["add", "edit", "remove", "export"];
  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="/bankaccount/routings"
    deleteSuffix="/bankaccount/bank-routings"
    columnLabelsDictionary={{ routingCode: "Routing Number", paymentType: "Transfer Method" }}
  />;
};

const bankRoutingFields = (myForm) => {
  myForm.addCenteredGroup([myForm.getDropdownField("Bank", "/bankaccount/list-banks", { name: "bankOrganizationId", required: true })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Transfer Method	", "/metadata/list-wire-payment-methods", { name: "paymentMethodId", required: true })]);
  myForm.addCenteredGroup([myForm.getInputField("Routing Number", { name: "number", required: true, fieldType: GlobalConstants.InputTypes.NUMBER })]);
  return myForm;
};

const AddBankRoutingForm = () => {
  const myForm = bankRoutingFields(new BCFormController({}, { submitSuffix: "/bankaccount/create-bank-routing", submitMethod: "POST", blankWidth: 4 }));
  const formActions = ["save-new", "save-continue", "save-close", "close"];
  return (<LmsFormGenerator myForm={myForm} actions={formActions} />);
};

const EditBankRoutingForm = ({ id }) => {
  const [{ data = {}, isLoading, error }] = useFetchData(`/bankaccount/routings/${id}`);
  const myForm = bankRoutingFields(new BCFormController(data, { values: data, blankWidth: 4, submitSuffix: "/bankaccount/update-bank-routing",  submitMethod: "PUT", deleteSuffix: "/bankaccount/bank-routings" }));
  const formActions = ["save", "save-close", "delete", "close"];
  return <LmsFormGenerator myForm={myForm} isLoading={isLoading} error={error} actions={formActions}/>;
};

const LmsAccountingBankRoutings = ({ params = {}, history }) => {
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (<>
    {isMainPage && <MainTable/>}
    {isAdd && <AddBankRoutingForm />}
    {isEdit && <EditBankRoutingForm id={id}/>}
  </>);
};

export default LmsAccountingBankRoutings;